import React from "react";
import MasonryGallery from "../components/MasonryGallery";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const CustomCursor = () => {
    const [position, setPosition] = React.useState({ x: 0, y: 0 });
    const [isHovering, setIsHovering] = React.useState(false);

    React.useEffect(() => {
        const handleMouseMove = (e) => {
            setPosition({ x: e.clientX, y: e.clientY });
        };

        const handleMouseOver = (e) => {
            if (e.target.closest("button, a, .cursor-hover")) {
                setIsHovering(true);
            } else {
                setIsHovering(false);
            }
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseover", handleMouseOver);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("mouseover", handleMouseOver);
        };
    }, []);

    return (
        <div
            className="fixed pointer-events-none z-[9999] mix-blend-difference hidden md:block"
            style={{
                left: position.x,
                top: position.y,
                transform: "translate(-50%, -50%)",
            }}
        >
            <div
                className={`rounded-full bg-white transition-all duration-300 ease-out ${
                    isHovering ? "w-7 h-7 opacity-50" : "w-3 h-3 opacity-100"
                }`}
            />
        </div>
    );
};

const Toddlers = () => {
    const images = [
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t1.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t2.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t3.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t4.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t5.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t6.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t7.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t8.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t9.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t10.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t11.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t12.webp",
        "/assets/toddlers-webp/t13.webp",
        "/assets/toddlers-webp/t14.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t15.webp",
        "/assets/toddlers-webp/t16.webp",
        "/assets/toddlers-webp/t17.webp",
        "/assets/toddlers-webp/t18.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t19.webp",
        "/assets/toddlers-webp/t20.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t21.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t22.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t23.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t24.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t25.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t26.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t27.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t28.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t29.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t30.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t31.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t32.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t33.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t34.webp",
        "/assets/toddlers-webp/t35.webp",
        "/assets/toddlers-webp/t36.webp",
        "/assets/toddlers-webp/t37.webp",
        "/assets/toddlers-webp/t38.webp",
        "/assets/toddlers-webp/t39.webp",
        "/assets/toddlers-webp/t40.webp",
        "/assets/toddlers-webp/t41.webp",
        "/assets/toddlers-webp/t42.webp",
        "/assets/toddlers-webp/t43.webp",
        "/assets/toddlers-webp/t44.webp",
        "/assets/toddlers-webp/t45.webp",
        "/assets/toddlers-webp/t46.webp",
        "/assets/toddlers-webp/t47.webp",
        "/assets/toddlers-webp/t48.webp",
        "/assets/toddlers-webp/t49.webp",
        "/assets/toddlers-webp/t50.webp",
        "/assets/toddlers-webp/t51.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t52.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t53.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t54.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t55.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t56.webp",
        "https://ik.imagekit.io/p3xaqnkci/tagteam/toddlers/toddlers-webp/t57.webp",
        "/assets/toddlers-webp/t58.webp",
        "/assets/toddlers-webp/t59.webp",
        "/assets/toddlers-webp/t60.webp",
        "/assets/toddlers-webp/t61.webp",
        "/assets/toddlers-webp/t62.webp",
        "/assets/toddlers-webp/t63.webp",
        "/assets/toddlers-webp/t64.webp",
        "/assets/toddlers-webp/t65.webp",
        "/assets/toddlers-webp/t66.webp",
        "/assets/toddlers-webp/t67.webp",
        "/assets/toddlers-webp/t68.webp",
        "/assets/toddlers-webp/t69.webp",
        "/assets/toddlers-webp/t70.webp",
        "/assets/toddlers-webp/t71.webp",        
    ];

    return (
        <div className="bg-neutral-950 min-h-screen" style={{ cursor: "none" }}>
            <CustomCursor />
            <Navigation />
            <MasonryGallery
                title="Family Portraits"
                subtitle="TAGTEAM TODDLERS"
                images={images}
            />

            <Footer />
        </div>
    );
};

export default Toddlers;
